import Link from "next/link"
import BasicSwiper from "../../_SharedComponents/BasicSwiper/BasicSwiper"
import PhoneSwiper from "../../_SharedComponents/PhoneSwiper/PhoneSwiper"
import styles from "./SwiperSection.module.css"
import { Button } from "antd"
import { IPTrackingContext } from "../../../context/IPTracking.context"
import { useContext } from "react"
import { TrackGoogleAnalyticsEvent } from "../../../Tracking/GoogleTracking"
import notificationService from "../../../services/notification.service"

const SwiperSection = () => {
  const { IPTrackingData } = useContext(IPTrackingContext)
  const handleButtonClick = async () => {
    try {
      TrackGoogleAnalyticsEvent(
        "Home Page | Elige la tarifa ideal botón",
        "Home Page | Elige la tarifa ideal botón",
        "Home Page | Elige la tarifa ideal botón"
      )
      await notificationService.sendNotification({
        title: "Home Page Elige la tarifa ideal",
        text: `Home Page Elige la tarifa ideal Button clicked\\n IP Track:${
          IPTrackingData ? IPTrackingData : ""
        }`,
        subject: "Home Page Elige la tarifa ideal",
        receiver: "SUPER",
      })
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <section style={{ display: "flex", flexDirection: "column" }}>
      <div className={styles.swiper}>
        <BasicSwiper title={"Comparamos en más de 50 compañías"} />
        <Link href="/sube-tu-factura" passHref>
          <a
            aria-label="Sube tu factura para comparar tarifas"
            title="Sube tu factura para comparar tarifas"
          >
            <Button
              type="primary"
              size="large"
              className={styles.onlineButtonClass}
              onClick={handleButtonClick}
            >
              <span>Elige la tarifa ideal</span>
              <span style={{ marginLeft: "10px" }}>
                <img src="/icons/UpVector.svg" alt="Up" />
              </span>
            </Button>
          </a>
        </Link>
      </div>
      <div className={styles.phoneSwiper}>
        <PhoneSwiper title={"Comparamos en más de 50 compañías"} />
        <Link href="/sube-tu-factura" passHref>
          <a
            aria-label="Sube tu factura para comparar tarifas"
            title="Sube tu factura para comparar tarifas"
          >
            <Button
              type="primary"
              size="large"
              className={styles.onlineButtonClass}
              onClick={handleButtonClick}
            >
              <span>Elige la tarifa ideal</span>
              <span style={{ marginLeft: "10px" }}>
                <img src="/icons/UpVector.svg" alt="Up" />
              </span>
            </Button>
          </a>
        </Link>
      </div>
    </section>
  )
}

export default SwiperSection
